// Copyright (c) 2025, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

/**
 * Returns true if the exam expired within the last 7 days or will expire within the next 7 days.
 * Used to determine if an exam is eligible for extension.
 *
 * Eligibility window: [today - 7 days, today + 7 days]
 *
 * @param expirationDate - The expiration date string (ISO format)
 * @returns boolean - True if eligible for extension
 */
const daysBetween = (a: Date, b: Date): number => {
  const dateA = new Date(a);
  const dateB = new Date(b);
  dateA.setHours(0, 0, 0, 0);
  dateB.setHours(0, 0, 0, 0);
  return Math.abs(Math.floor((dateA.getTime() - dateB.getTime()) / (1000 * 60 * 60 * 24)));
};

export function isExamEligibleForExtension(expirationDate: string): boolean {
  return daysBetween(new Date(), new Date(expirationDate)) <= 7;
}
